module.exports = __webpack_public_path__ + "static/media/logo-rosa.cff895b4.jpg";